











import Vue from 'vue'
import { examInfo } from '../../utils/ExmasForTensakuVisiter/type'

export default Vue.extend({
  props: {
    info: {
      type: Object as () => examInfo,
      required: false
    }
  },
})
